import {ReactElement} from 'react';
import { ContentWrapperDiv } from './AppBodyStyle';

interface AppBodyProps {
  children: any;
  overflow?: 'hidden' | 'auto' | 'scroll' | 'visible';
}

const AppBodyContent = (props: AppBodyProps): ReactElement => {
  const {children, overflow = 'visible'} = props;

  return <ContentWrapperDiv overflow={overflow}>{children}</ContentWrapperDiv>;
};

export default AppBodyContent;